/* eslint @typescript-eslint/no-var-requires: "off" */
import { UtilTypes } from '@briq/core'

import alertCircleBlue from '../assets/icons/alert-circle-blue.svg'
import alertCircleOrange from '../assets/icons/alert-circle-orange.svg'
import arrowLeftBlue from '../assets/icons/atom-icon-s-arrow-left.svg'
import arrowLeftWhite from '../assets/icons/arrow-left-white.svg'
import arrowRight2White from '../assets/icons/arrow-right2-white.svg'
import arrowRightBlue from '../assets/icons/arrow-right-blue.svg'
import arrowRight2Blue from '../assets/icons/arrow-right2-blue.svg'
import arrowRightWhite from '../assets/icons/arrow-right-white.svg'
import bell from '../assets/icons/bell.svg'
import bellWhite from '../assets/icons/bell-white.svg'
import arrowUpBlue from '../assets/icons/arrow-up-blue.svg'
import arrowUpWhite from '../assets/icons/arrow-up-white.svg'
import callingCard from '../assets/icons/calling-card.svg'
import caseBlue from '../assets/icons/case-blue.svg'
import caseOrange from '../assets/icons/case-orange.svg'
import caseWhite from '../assets/icons/case-white.svg'
import chevronRight from '../assets/icons/chevron-right.svg'
import closeBlack from '../assets/icons/close-black.svg'
import closeWhite from '../assets/icons/close-white.svg'
import codeWhite from '../assets/icons/code-white.svg'
import creditCardWhite from '../assets/icons/credit-card-white.svg'
import creditCardBlue from '../assets/icons/credit-card-blue.svg'
import down from '../assets/icons/down.svg'
import downloadBlue from '../assets/icons/download-blue.svg'
import downloadWhite from '../assets/icons/download-white.svg'
import editPaperWhite from '../assets/icons/edit-paper-white.svg'
import empty from '../assets/icons/empty.svg'
import emptyCircle from '../assets/icons/empty-circle.svg'
import envelope from '../assets/icons/envelope.svg'
import envelopeWhite from '../assets/icons/envelope-white.svg'
import fileText from '../assets/icons/file-text.svg'
import fileTextWhite from '../assets/icons/file-text-white.svg'
import flagHi from '../assets/icons/flag-hi.svg'
import flagId from '../assets/icons/flag-id.svg'
import flagMs from '../assets/icons/flag-ms.svg'
import flagUs from '../assets/icons/flag-us.svg'
import flagVi from '../assets/icons/flag-vi.svg'
import homeWhite from '../assets/icons/home-white.svg'
import iconFilterBlue from '../assets/icons/icon-filter-blue.svg'
import iconSUserSingleWhite from '../assets/icons/icon-s-user-single-white.svg'
import infoOrange from '../assets/icons/info-orange.svg'
import leftBlue from '../assets/icons/left-blue.svg'
import lockCloseWhite from '../assets/icons/lock-close-white.svg'
import lockGlobeWhite from '../assets/icons/atom-icon-s-map-globe.svg'
import logOut from '../assets/icons/log-out.svg'
import logOutWhite from '../assets/icons/log-out-white.svg'
import mail from '../assets/icons/mail.svg'
import mailWhite from '../assets/icons/mail-white.svg'
import personPrimary from '../assets/icons/person-primary.svg'
import phoneIconWhite from '../assets/icons/phone-icon-white.svg'
import phoneIconBlue from '../assets/icons/phone-icon-blue.svg'
import phoneNormalWhite from '../assets/icons/phone-normal-white.svg'
import playerPhoneCallWhite from '../assets/icons/player-phone-call-white.svg'
import question from '../assets/icons/question.svg'
import refreshCcwWhite from '../assets/icons/refresh-ccw-white.svg'
import search from '../assets/icons/search.svg'
import searchWhite from '../assets/icons/search-white.svg'
import shareWhite from '../assets/icons/share-white.svg'
import shoppingCart from '../assets/icons/shopping-cart.svg'
import shoppingCartWhite from '../assets/icons/shopping-cart-white.svg'
import plusCircleEmpty from '../assets/icons/atom-icon-s-plus-circle-empty.svg'
import plusCircleEmptyWhite from '../assets/icons/atom-icon-s-plus-circle-empty-white.svg'
import single from '../assets/icons/single.svg'
import starFull from '../assets/icons/atom-icon-s-star-full.svg'
import stepCircleActive from '../assets/icons/step-circle-active.svg'
import stepCircleInactive from '../assets/icons/step-circle-inactive.svg'
import trash2White from '../assets/icons/trash-2-white.svg'
import trashBlue from '../assets/icons/icon-trash-blue.svg'
import triangleDown from '../assets/icons/triangle-down.svg'
import up from '../assets/icons/up.svg'
import user from '../assets/icons/user.svg'
import userCheck from '../assets/icons/user-check.svg'
import userLoggedOut from '../assets/icons/user-logged-out.svg'
import writingBlue from '../assets/icons/writing-blue.svg'
import headerBackground from '../assets/images/header-background.svg'
import illustrationCart from '../assets/images/illustration-cart.svg'
import logoPrimary from '../assets/images/logo_primary.svg'
import logoPrimaryInverse from '../assets/images/logo_primary_inverse.svg'
import logoMastercard from '../assets/images/logo-mastercard.svg'
import logoPaypal from '../assets/images/logo-paypal.svg'
import logoVisa from '../assets/images/logo-visa.svg'
import searchBannerBackground from '../assets/images/search-banner-background.svg'
import target from '../assets/images/target.svg'
import whoWeAre from '../assets/images/who-we-are.svg'
import filePlus from '../assets/icons/atom-icon-s-file-plus.svg'
import filePlusWhite from '../assets/icons/atom-icon-s-file-plus-white.svg'
import save from '../assets/icons/atom-icon-s-save.svg'
import chatsBlue from '../assets/icons/chats-blue.svg'

export const images: UtilTypes.Dictionary<string> = {
  alertCircleBlue,
  alertCircleOrange,
  arrowLeftBlue,
  arrowLeftWhite,
  arrowRight2White,
  arrowRightBlue,
  arrowRight2Blue,
  arrowRightWhite,
  bell,
  bellWhite,
  arrowUpBlue,
  arrowUpWhite,
  callingCard,
  caseBlue,
  caseOrange,
  caseWhite,
  chevronRight,
  closeBlack,
  closeWhite,
  codeWhite,
  creditCardWhite,
  creditCardBlue,
  down,
  downloadBlue,
  downloadWhite,
  editPaperWhite,
  empty,
  emptyCircle,
  envelope,
  envelopeWhite,
  fileText,
  fileTextWhite,
  flagHi,
  flagId,
  flagMs,
  flagUs,
  flagVi,
  homeWhite,
  iconFilterBlue,
  iconSUserSingleWhite,
  infoOrange,
  leftBlue,
  lockCloseWhite,
  lockGlobeWhite,
  logOut,
  logOutWhite,
  mail,
  mailWhite,
  personPrimary,
  phoneIconWhite,
  phoneIconBlue,
  phoneNormalWhite,
  playerPhoneCallWhite,
  question,
  refreshCcwWhite,
  search,
  searchWhite,
  shareWhite,
  shoppingCart,
  shoppingCartWhite,
  plusCircleEmpty,
  plusCircleEmptyWhite,
  single,
  starFull,
  stepCircleActive,
  stepCircleInactive,
  trash2White,
  trashBlue,
  triangleDown,
  up,
  user,
  userCheck,
  userLoggedOut,
  writingBlue,
  headerBackground,
  illustrationCart,
  logoPrimary,
  logoPrimaryInverse,
  logoMastercard,
  logoPaypal,
  logoVisa,
  searchBannerBackground,
  target,
  whoWeAre,
  filePlus,
  filePlusWhite,
  save,
  chatsBlue
}
